import { render, staticRenderFns } from "./InsNotice.vue?vue&type=template&id=745b8070&scoped=true"
import script from "./InsNotice.vue?vue&type=script&lang=ts"
export * from "./InsNotice.vue?vue&type=script&lang=ts"
import style0 from "./InsNotice.vue?vue&type=style&index=0&id=745b8070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b8070",
  null
  
)

export default component.exports